import { SubmittalProps } from "@/interfaces/submittal_types";
import { ProgressBar } from "./ProgressBar";
import { NamesInCategory } from "./NamesInCategory";
type SubmittalOverviewProps = {
    submittals: SubmittalProps[];
    submittalCounts: { [key: string]: { total: number; completed: number; }; };
    totalSubmittals: number;
    totalProgress: number;
}

export function SubmittalOverview({ submittals, submittalCounts, totalSubmittals, totalProgress }: SubmittalOverviewProps) {
    const users = NamesInCategory(submittals)
    return (
        <div>
            <h3 className="mb-2 text-stone-900 dark:text-stone-50">Submittal Overview: {totalSubmittals > 0 && totalSubmittals + " Submittals"}</h3>
            {submittals.length > 0 ? (
                <div className="bg-stone-100 dark:bg-stone-800 rounded-md p-4 border-2 border-stone-200 dark:border-stone-700">
                    <div className="flex flex-col gap-2">
                        <ProgressBar 
                            label="Mechanical"
                            completed={submittalCounts.Mechanical.completed}
                            total={submittalCounts.Mechanical.total}
                            barColor="bg-green-200"
                            users={users.Mechanical}
                        />
                        <ProgressBar 
                            label="Electrical"
                            completed={submittalCounts.Electrical.completed}
                            total={submittalCounts.Electrical.total}
                            barColor="bg-yellow-200"
                            users={users.Electrical}
                        />
                        <ProgressBar 
                            label="Plumbing"
                            completed={submittalCounts.Plumbing.completed}
                            total={submittalCounts.Plumbing.total}
                            barColor="bg-blue-200"
                            users={users.Plumbing}
                        />
                        <ProgressBar 
                            label="Fire Protection"
                            completed={submittalCounts["Fire Protection"].completed}
                            total={submittalCounts["Fire Protection"].total}
                            barColor="bg-red-200"
                            users={users["Fire Protection"]}
                        />
                        <ProgressBar 
                            label="Other"
                            completed={submittalCounts.Other.completed}
                            total={submittalCounts.Other.total}
                            barColor="bg-purple-200"
                            users={users.Other}
                        />
                    </div>

                    <p className="text-nowrap mt-2 text-stone-900 dark:text-stone-50">Total Progress: {totalProgress.toFixed(2)}%</p>
                    {totalProgress === 100 && <p className="text-green-500 text-nowrap mt-2 text-stone-900 dark:text-stone-50">All Submittals are Closed!</p>}
                </div>
            ) : (
                <p className="text-stone-900 dark:text-stone-50">(No submittals found)</p>
            )}
        </div>
    );
}
